<template>
    <div class="manufacturers">
        <div class="manufacturer-list">
            <manufacturer-filters  :selected="multipleSelection" @update-filters="onUpdateFilters" ref="filtersComponent"></manufacturer-filters>
            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} fournisseurs</div>
                <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
            </div>
            <el-table style="width: 100%" ref="multipleTable" :data="manufacturers"  stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="Nom Speedway" sortable="custom"></el-table-column>
                <el-table-column prop="shop_id" label="ID Speedway" sortable="custom"></el-table-column>
                <el-table-column prop="connector_name" label="Nom" sortable="custom"></el-table-column>
                <el-table-column label="Actions" fixed="right">
                    <template slot-scope="scope">
                        <a :href="'/catalog?q=brand:'+scope.row.id+appendSearch" v-if="scope.row.products_count">
                            <i class="fe fe-book-open"></i>
                            <span v-if="scope.row.search_query_count">/ {{ scope.row.search_query_count }}</span>
                            <span v-if="!scope.row.search_query_count && scope.row.brand_products_count">/ {{ scope.row.brand_products_count }}</span>
                        </a>
                        <a href="#" @click.prevent="openEdit(scope.row)" >
                            <i class="fe fe-upload"></i>
                        </a>
                        &nbsp;
                        <template v-if="scope.row.connector.stockEnabled">
                            <a href="#" @click.prevent="openStock(scope.row)" >
                                <i class="fe fe-box"></i>
                            </a>
                        </template>
                        <template v-else>
                            <i class="fe fe-box" style="opacity: 0.4"></i>
                        </template>

                        &nbsp;<template v-if="scope.row.connector.priceEnabled || true">
                            <a href="#" @click.prevent="openPrices(scope.row)" >
                                <i class="fe fe-dollar-sign"></i>
                            </a>
                        </template>
                        <template v-else>
                            <i class="fe fe-dollar-sign" style="opacity: 0.4"></i>
                        </template>

                        <a title="fichiers d'import" :href="'/manufacturers/'+scope.row.connector_name+'/importFiles'" target="_blank" >
                            <i class="fe fe-file"></i>
                        </a>

                        <template v-if="user && user.can('cut stock')">
                            <!-- Si stockable est à 0, bouton bloqué -->
                            <template v-if="scope.row.connector.stockable === 0">
                                <span title="Stock à implémenter en code" style="opacity: 0.4; cursor: not-allowed;">
                                    <i class="fe fe-slash"></i>
                                </span>
                            </template>
                            <!-- Sinon bouton actif avec tooltip adaptatif -->
                            <template v-else>
                                <a href="#" @click.prevent="openCutStock(scope.row)" :title="scope.row.connector.stockEnabled ? 'Couper le stock' : 'Activer le stock'">
                                    <i class="fe" :class='{"fe-slash": scope.row.connector.stockEnabled, "fe-check-circle red": !scope.row.connector.stockEnabled}'></i>
                                </a>
                            </template>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>
        </div>

        <el-dialog @closed="closeEdit" :title="'Synchroniser '+ createEdit.form.name" v-loading="createEdit.loader" :visible.sync="createEdit.display" width="50%">
            <el-form class="formCreateEdit" ref="formCreateEdit" :rules="rules" :model="createEdit.form" label-position="top">
                <div v-if="createEdit.form.synchro_file_list">
                    Liste des fichiers necessaires :
                    <ul>
                        <li v-for="(fileItem, index) in createEdit.form.synchro_file_list" :key="index">
                            <a v-if="fileItem.link" :href="fileItem.link" target="_blank">{{ fileItem.name }}</a>
                            <span v-else>{{ fileItem.name }}</span>
                        </li>
                    </ul>

                    <el-input placeholder="URL du fichier" type="url" v-model="file_url">
                        <template slot="prepend">Http(s)://</template>
                        <el-button slot="append" v-if="url_uploader" icon="el-icon-loading"></el-button>
                        <template v-if="url_upload_end">
                            <el-button slot="append" v-if="url_upload_success" icon="el-icon-check"></el-button>
                            <el-button slot="append" v-if="!url_upload_success" icon="el-icon-warning"></el-button>
                        </template>
                        <el-button slot="append" icon="el-icon-search" class="success" @click="handleChangeFileUrl(file_url)"></el-button>
                    </el-input>
                    <el-alert class="m-2" v-if="url_upload_error" :title="url_upload_error" type="error" show-icon></el-alert>
                    <p class="text-muted">Insérer l'URL d'un des fichiers listés<br />OU</p>

                    <el-upload ref="uploadManufacturerCatalog" accept="application/csv,application/xls,.xlsx" :before-upload="checkFileUpload" :headers="headersUpload" class="upload-image-product" drag action="/manufacturers" :data="{manufacturer_id: createEdit.form.id}" :on-success="uploadSuccess" :file-list="fileList" multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Déposer les fichiers ici ou
                            <em>cliquez pour téléverser</em>
                        </div>
                        <div class="el-upload__tip" slot="tip">taille inférieur à 30 Mo</div>
                </el-upload>
                </div>
                <div v-else>
                    Pas de fichier à envoyer, vous pouvez synchroniser
                </div>
                <div v-if="createEdit.form.connector_name == 'bihr'">
                    <el-form-item prop="brand_id" label="Marques">
                        <el-select clearable v-model="options['only-brands']" placeholder="Marques" multiple filterable>
                            <el-option v-for="item in brandsOptions" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-if="createEdit.form.connector_name == 'bihr'">
                    <el-form-item prop="category_id" label="Catégorie">
                        <el-select clearable v-model="options['only-categories']" placeholder="Catégories" multiple filterable>
                            <el-option v-for="item in categoriesOptions" :key="item.shop_id" :label="item.name" :value="item.shop_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="createEdit.display = false">Annuler</el-button>
                <el-button :disabled="!syncReadyToGo" v-if="createEdit.form.synchro_file_list" type="primary" @click="update">Envoyer le(s) fichier et Synchroniser</el-button>
                <el-button :disabled="!syncReadyToGo" v-else type="primary" @click="update">Synchroniser</el-button>
            </span>
        </el-dialog>

        <el-dialog @closed="closeStock" :title="'Stock '+ modalStock.form.name" v-loading="modalStock.loader" :visible.sync="modalStock.display" width="50%">
            <el-form class="formModalStock" ref="formModalStock" :rules="rules" :model="modalStock.form" label-position="top">
                <div>
                    Syncronise le stock avec le Prestashop
                </div>
                <div v-if="modalStock.list.length == 1">
                    Dernier fichier de stock : <a :href="'/manufacturers/'+modalStock.form.id+'/last-stock'">télécharger</a>
                </div>
                <div v-if="modalStock.list.length > 1">
                    Dernier fichier de stock :
                    <ul>
                        <li :key="file.basename" v-for="file in modalStock.list" >
                            <a :href="'/manufacturers/'+modalStock.form.id+'/last-stock?f='+file.filename">{{file.filename}}</a>
                            <template v-if="file.filename.match(/override_stock/)">
                                <a class="text-danger" href="#" @click.prevent="removeOverrideStock">
                                    <i class="fe fe-trash"></i>
                                </a>
                            </template>
                        </li>
                    </ul>
                </div>
                <div class="mt-4" v-if="modalStock.form.connector && modalStock.form.connector.newStock">
                    Envoyer un fichier d'override de stock<br>
                    Fichier d'exemple : <a href="infos/override_stock.xlsx">télécharger</a>
                    <el-upload
                        ref="overrideStock"
                        accept="application/csv,application/xls,.xlsx"
                        :headers="headersUpload"
                        class="upload-image-product"
                        drag
                        :action="`/manufacturers/${modalStock.form.id}/overrideStock`"
                        :on-success="uploadSuccessOverrideStock"
                        >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Déposer les fichiers ici ou
                            <em>cliquez pour téléverser</em>
                        </div>
                        <div class="el-upload__tip" slot="tip">taille inférieur à 30 Mo</div>
                    </el-upload>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalStock.display = false">Annuler</el-button>
                <el-button type="primary" @click="actionStock">Synchroniser</el-button>
            </span>
        </el-dialog>
        <el-dialog @closed="closePrices" :title="'Prix '+ modalPrices.form.name" v-loading="modalPrices.loader" :visible.sync="modalPrices.display" width="50%">
            <el-form class="formModalPrices" ref="formModalPrices" :rules="rules" :model="modalPrices.form" label-position="top">
                <div v-if="modalPrices.form.connector_name != 'motogest' && modalPrices.form.connector_name != 'bihr'">
                    Envoi les prix sur le Prestashop
                    <div class="mt-3">
                        <el-checkbox v-model="modalPrices.options.allPrice">Envoyé tous les prix et pas que les changements ?</el-checkbox>
                    </div>
                </div>
                <div v-else>
                    Met à jour les prix
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalPrices.display = false">Annuler</el-button>
                <el-button type="primary" @click="actionPrices">Synchroniser</el-button>
            </span>
        </el-dialog>

        <el-dialog @closed="closeCutStock" :title="stockModalTitle" v-loading="modalCutStock.loader" :visible.sync="modalCutStock.display" width="50%">
            <div>
                {{ stockModalMessage }}
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalCutStock.display = false">Annuler</el-button>
                <el-button type="primary" @click="actionCutStock">{{ stockModalButtonText }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import queryString from 'query-string';
import { EventBus } from '../../event-bus';
import Manufacturer from '../../models/Manufacturer';
import draggable from 'vuedraggable'
import {
    validUrl,
} from '../../utils/url'
export default {
    components: {
        draggable,
    },
    data() {
        return {
            multipleSelection: [],
            file_url: null,
            url_uploader: false,
            url_upload_success: false,
            url_upload_end: false,
            url_upload_error: null,
            headersUpload: {
                'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
            },
            options: {
                'only-brands': [],
                'only-categories': [],
            },
            brandsOptions: [],
            categoriesOptions: [],
            syncReadyToGo: true,
            fileList: [],
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            filters: {},
            loading: false,
            rules: {
                name: [
                    {
                        required: true,
                        message: 'Veuillez renseignez un nom',
                        trigger: 'blur'
                    }
                ],
                shop_id: [
                    {
                        required: true,
                        message: 'Veuillez renseigner un ShopId',
                        trigger: 'blur'
                    },
                ],
            },
            modal: {
                display: false,
                brand: {}
            },
            createEdit: {
                display: false,
                loader: false,
                form: {
                    sendPrice: false
                }
            },
            modalStock: {
                display: false,
                loader: false,
                list: [],
                options: {
                    put: true
                },
                form: {
                }
            },
            modalPrices: {
                display: false,
                loader: false,
                options: {
                    put: true,
                    allPrice: false
                },
                form: {

                }
            },
            modalCutStock: {
                display: false,
                loader: false,
                form: {
                }
            }
        };
    },
    computed: {
        total_item() {
            return this.$store.getters['manufacturers/totalItems'];
        },
        manufacturers() {
            return this.$store.getters['manufacturers/items'];
        },
        user() {
            return this.$store.getters['app/user'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
        appendSearch() {
            var query = this.params['product_search'] ? ' '+this.params['product_search'] + '&scope=name' : ''
            if( this.params.category_id ) {
                this.params.category_id.forEach((v)=>{
                    query += '&category_id='+v
                })
            }
            return query;
        },
        stockModalTitle() {
            if (!this.modalCutStock.form.connector) return '';
            const action = this.modalCutStock.form.connector.stockEnabled ? 'Couper le stock' : 'Activer le stock';
            return `${action} ${this.modalCutStock.form.name}`;
        },
        stockModalMessage() {
            if (!this.modalCutStock.form.connector) return '';
            if (this.modalCutStock.form.connector.stockEnabled) {
                return 'Êtes-vous certains de déconnecter le stock fournisseur ? Cela impactera la visibilité des produits.';
            } else {
                return 'Voulez vous réactiver le stock ?';
            }
        },
        stockModalButtonText() {
            if (!this.modalCutStock.form.connector) return 'Oui';
            return this.modalCutStock.form.connector.stockEnabled ? 'Couper le stock' : 'Activer le stock';
        }
    },
    watch: {
        params: {
            handler(newV, oldV) {
                var newUrl =
                    this.currentUrl + '?' + queryString.stringify(newV);
                window.history.pushState({ path: newUrl }, '', newUrl);
            },
            deep: true
        }
    },
    mounted() {
        this.$store.dispatch('app/setSearchMode', 'manufacturers');
        this.fetch();

    },

    methods: {

        removeOverrideStock() {
            this.$confirm('Êtes-vous sûr de vouloir supprimer le fichier d\'override de stock ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
                type: 'warning'
            }).then(() => {
                axios.delete('/manufacturers/'+this.modalStock.form.id+'/overrideStock').then((r)=>{
                    this.$message({
                        showClose: true,
                        message: r.data.message,
                        type: 'success',
                        duration: 5000
                    });
                    this.modalStock.list = r.data.list;
                }).catch((r)=>{
                    this.$message({
                        showClose: true,
                        message: r.response.data.message,
                        type: 'error',
                        duration: 5000
                    });
                });
            }).catch(() => {});
        },

        uploadSuccessOverrideStock(response, file, fileList) {
            this.$message({
                showClose: true,
                message: response.message,
                type: 'success',
                duration: 5000
            });
            this.modalStock.list = response.list;
        },

        uploadSuccess(response, file, fileList) {

            var finish = fileList.filter(v => v.status == 'success');
            finish = finish.filter(
                v => this.createEdit.form.synchro_file_list.find( v => v.name == v.response.data.filename)
            );

            if (finish.length == this.createEdit.form.synchro_file_list.length) {
                this.syncReadyToGo = true;
            }
        },
        handleChangeFileUrl(value) {
            this.url_upload_end = false
            this.url_upload_error = null

            if (value.indexOf('http://') == -1 && value.indexOf('https://') == -1) {
                value = 'http://' + value;
            }

            if (validUrl(value)) {
                this.url_uploader = true
                axios.post('/manufacturers', {
                    file_url: value,
                    manufacturer_id: this.createEdit.form.id
                }).then((response) => {
                    this.url_upload_success = true
                    this.file_url = null;
                }).catch((r) => {
                    this.url_upload_success = false
                    this.url_upload_error = r.response.data.message
                }).then(() => {
                    this.url_upload_end = true
                    this.url_uploader = false
                })
            } else {
                this.url_upload_error = 'URL invalide'
            }
        },
        checkFileUpload(file) {
            var maxSizeMo = 500;
            var maxSizeBit = maxSizeMo * 1048576;
            let finded = this.createEdit.form.synchro_file_list.find(v => v.name == file.name);
            if( !finded && file.name != 'images.zip'){
                this.$message({
                    showClose: true,
                    message: "Ce n'est pas le bon nom de fichier",
                    type: 'error',
                    duration: 5000
                });
                return false;
            }
            if (file.size > maxSizeBit) {
                this.$message({
                    showClose: true,
                    message: "Poids du fichier trop lourd, pas plus de 30 Mo ",
                    type: 'error',
                    duration: 5000
                });
                return false;
            }
            return true;
        },
        update()
        {
            this.$refs.formCreateEdit.validate((valid, errors) => {
                if (valid) {
                    if( this.createEdit.form.id ) {

                        axios
                        .post('/manufacturers/syncCatalog/' + this.createEdit.form.id, {
                            mode: 'sync_catalog',
                            options: this.options
                        })
                        .then(r => {
                            this.$message({
                                type: 'success',
                                message: r.data.message
                            });
                            this.closeEdit();
                        })
                        .catch(e => {
                            if (e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(e.response.data.message);
                            }
                        })
                        .then(() => {});
                    }
                }
            })
        },
        actionStock()
        {
            axios
            .post('/manufacturers/syncCatalog/' + this.modalStock.form.id, {
                mode: 'sync_stock',
                options: this.modalStock.options
            })
            .then(r => {
                this.$message({
                    type: 'success',
                    message: r.data.message
                });
                this.closeStock();
            })
            .catch(e => {
                if (e.response.status == 422) {
                    this.$message.error(e.response.data.errors);
                } else {
                    this.$message.error(e.response.data.message);
                }
            })
            .then(() => {});

        },
        async openStock( manufacturer )
        {
            if( !manufacturer ) {
                manufacturer = new Manufacturer
            }
            this.options = {
            }
            this.modalStock.form = manufacturer.toDatas();

            try {
                let response = await axios.get('/manufacturers/'+this.modalStock.form.id+'/list-last-stock');
                this.modalStock.list = response.data.list;
            } catch(e) {
                this.modalStock.list = [];
            }

            this.modalStock.display = true;
        },
        closeStock()
        {
            this.modalStock.form = { };
            this.modalStock.display = false;
        },
        actionPrices()
        {
            var mode = 'sync_prices';

            if( this.modalPrices.form.connector_name != 'motogest' && this.modalPrices.form.connector_name != 'bihr' ) {
                mode = 'send_prices';
            }

            axios
                .post('/manufacturers/syncCatalog/' + this.modalPrices.form.id, {
                    mode,
                    options: this.modalPrices.options
                })
                .then(r => {
                    this.$message({
                        type: 'success',
                        message: r.data.message
                    });
                    this.closePrices();
                })
                .catch(e => {
                    if (e.response.status == 422) {
                        this.$message.error(e.response.data.errors);
                    } else {
                        this.$message.error(e.response.data.message);
                    }
                })
                .then(() => {});
        },
        openPrices( manufacturer )
        {
            if( !manufacturer ) {
                manufacturer = new Manufacturer
            }

            this.options = {
            }
            this.modalPrices.options.allPrice = false;
            this.modalPrices.form = manufacturer.toDatas();
            this.modalPrices.display = true;
        },
        closePrices()
        {
            this.modalPrices.form = { };
            this.modalPrices.display = false;
        },
        openEdit( manufacturer )
        {
            if( !manufacturer ) {
                manufacturer = new Manufacturer
            }
            axios.get('/brands').then(r => {
                this.brandsOptions = r.data.data;
            });
            axios.get('/categories?mode=list&limit=99999').then(r => {
                this.categoriesOptions = r.data.data;
            });
            this.options = {
                'only-brands': [],
                'only-categories': [],
            }
            this.createEdit.form = manufacturer.toDatas();
            this.createEdit.display = true;
            if(!this.createEdit.form.synchro_file_list){
                this.syncReadyToGo = true;
            }else{
                this.syncReadyToGo = true;
                this.createEdit.form.synchro_file_list = this.createEdit.form.synchro_file_list.map((v)=>{
                    let finded = this.createEdit.form.files.find((vv)=>{
                        let regex = new RegExp('\/'+v);
                        return vv.match(regex);
                    });
                    return {
                        name: v,
                        link: finded ? '/manufacturers/file/'+finded : null
                    };
                });
            }


        },
        closeEdit()
        {
            this.createEdit.form = { };
            this.createEdit.display = false;
        },

        fetch(params) {
            if (!params) {
                params = {};
            }
            params = { ...params, ...this.params };
            params.exclude_id = [9];
            this.loading = true;
            return this.$store.dispatch('manufacturers/fetch', params).then(() => {
                this.loading = false;
            });
        },

        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },

        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },

        openModalEdit(brand) {
            this.modal.display = true;
            this.modal.brand = brand.clone();
        },

        closeModalEdit() {
            this.modal.display = false;
        },

        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },

        onUpdateFilters(filters) {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...filters };
            if (!Object.values(filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },

        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.manufacturers .manufacturer-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },

        openCutStock(manufacturer) {
            if (!manufacturer) {
                manufacturer = new Manufacturer
            }
            this.modalCutStock.form = manufacturer.toDatas();
            this.modalCutStock.display = true;
        },

        closeCutStock() {
            this.modalCutStock.form = {};
            this.modalCutStock.display = false;
        },

        actionCutStock() {
            axios.post('/manufacturers/'+this.modalCutStock.form.connector_name+'/toggleStock')
                .then(r => {
                    this.$message({
                        type: 'success',
                        message: r.data.message
                    });
                    this.closeCutStock();
                    // Re-fetch pour mettre à jour la liste et le connector.stockEnabled
                    this.fetch();
                })
                .catch(e => {
                    if (e.response.status == 422) {
                        this.$message.error(e.response.data.errors);
                    } else {
                        this.$message.error(e.response.data.message);
                    }
                })
                .then(() => {});
        },
    }
};
</script>
<style lang="scss">
.manufacturers {
    .pagination {
        margin: 25px 0;
        .el-pagination {
            margin: 0 auto;
        }
    }
}

.red {
    color: red;
}
</style>
